import { LuLoader } from "react-icons/lu";

export const LoadingSpinner = (props: { text?: string }) => {
  const { text = "Loading..." } = props;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <LuLoader
        style={{
          animation: "spin 1.5s linear infinite",
          transformOrigin: "center",
          fontSize: "24px",
        }}
      ></LuLoader>
      <span style={{ fontSize: "16px" }}>{text}</span>
    </div>
  );
};
